<div class="flex flex-col min-h-[100dvh]">
  <app-menu></app-menu>
  <div class="flex-grow">
    <ng-content></ng-content>
  </div>
  <app-footer></app-footer>
</div>
